import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Do from "./Do";
import AboutMe from "./AboutMe";
import CodeStack from "./CodeStack";
import Timeline from "./Timeline";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: "black",
}));

export default function Home() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid sx={{ pb: 3 }}>
        <Item elevation={0}>
          <AboutMe />
        </Item>
        <Item elevation={0}>
          <CodeStack />
        </Item>
        <Item elevation={0}>
          <Do />
        </Item>
        <Item elevation={0}>
          <Timeline />
        </Item>
      </Grid>
    </Box>
  );
}
